module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img48.7da52019.jpg";